'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styles = require('./styles.scss');

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('ifeis.new-feis-grant', ['ngMaterial']).factory('fFeisGrantDialog', function ($mdDialog) {
  return function (ev) {
    return $mdDialog.show({
      controller: 'FeisGrantDialogController',
      template: require('./tpl.html'),
      targetEvent: ev
    });
  };
}).controller('FeisGrantDialogController', function ($scope, $mdDialog) {
  $scope.roles = [{ name: 'Chair', value: 'chair' }, { name: 'Perform Registrations', value: 'registration' }, { name: 'Manage Results', value: 'results' }, { name: 'Run Stages', value: 'stage' }, { name: 'Control Tabulations', value: 'tabulations' }];

  $scope.cancel = function () {
    $mdDialog.cancel();
  };

  $scope.create = function (g) {
    var grant = {
      role: g.role.value,
      email: g.email
    };

    $mdDialog.hide(grant);
  };
});


//////////////////
// WEBPACK FOOTER
// ./new-feis-grant/index.js
// module id = 486
// module chunks = 0